import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    fetchBlog,
    fetchBlogLiked,
    fetchBlogSaved,
} from "../../../features/blog/blogSlice";
import { fetchRelatedBlogs } from "../../../features/relatedBlogs/relatedBlogsSlice";
import Loading from "../../Loading";
import RelatedPosts from "./RelatedPosts";

const PostDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { blog, isLoading, isError, error } = useSelector(
        (state) => state.blog
    );

    const { title, tags, image, likes, isSaved, description } = blog;

    useEffect(() => {
        dispatch(fetchBlog(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (tags) {
            dispatch(fetchRelatedBlogs({ tags, id }));
        }
    }, [dispatch, tags, id]);

    if (isLoading || !blog) {
        return <Loading />;
    }

    if (isError) {
        return (
            <h1 className="text-xl mt-4" style={{ textAlign: "center" }}>
                {error}!
            </h1>
        );
    }

    return (
        <>
            {/* Go Home / Go Back */}
            <div className="container mt-8">
                <Link
                    to="/"
                    className="inline-block text-gray-600 home-btn"
                    id="lws-goHome"
                >
                    <i className="mr-2 fa-solid fa-house" />
                    Go Home
                </Link>
            </div>
            <section className="post-page-container">
                {/* detailed post  */}
                <main className="post">
                    <img
                        src={image}
                        alt="githum"
                        className="w-full rounded-md"
                        id="lws-megaThumb"
                    />
                    <div>
                        <h1
                            className="mt-6 text-2xl post-title"
                            id="lws-singleTitle"
                        >
                            {title}
                        </h1>
                        <div className="tags" id="lws-singleTags">
                            {/* <span>#python,</span> <span>#tech,</span>
                            <span>#git</span> */}
                            {blog?.tags?.map((tag) => (
                                <span key={tag}>#{tag}</span>
                            ))}
                        </div>
                        <div className="btn-group">
                            {/* handle like on button click */}
                            <button
                                className="like-btn"
                                id="lws-singleLinks"
                                onClick={() =>
                                    dispatch(fetchBlogLiked({ id, likes }))
                                }
                            >
                                <i className="fa-regular fa-thumbs-up" />
                                {likes}
                            </button>
                            {/* handle save on button click */}
                            {/* use ".active" class and "Saved" text  if a post is saved, other wise "Save" */}
                            <button
                                className={
                                    isSaved ? "active save-btn" : "save-btn"
                                }
                                id="lws-singleSavedBtn"
                                onClick={() =>
                                    dispatch(fetchBlogSaved({ id, isSaved }))
                                }
                            >
                                <i className="fa-regular fa-bookmark" />
                                {isSaved ? "Saved" : "Save"}
                            </button>
                        </div>
                        <div className="mt-6">
                            <p>{description}</p>
                        </div>
                    </div>
                </main>
                {/* detailed post ends */}
                {/* related posts */}
                <RelatedPosts tags={tags} id={id} />
                {/* related posts ends */}
            </section>
        </>
    );
};

export default PostDetails;
